import { useState, useEffect } from "react";
import { storeService } from "../../services/StoreService";

//function useStore(page: number | undefined): [any, any, any, any, any, any, any, any, boolean] {
function useStore(page: number | undefined): [any, boolean] {
  const [result, setResult] = useState({
    stores: [],
    hasMore: true,
    cursor: "",
    total: 0,
    /*countries:[],
        retailers:[],
        regions:[],
        channels:[],
        outlet_classes:[],
        manufacturers:[],
        sub_regions_1:[]*/
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        if (result.hasMore) {
          setLoading(true);
          const res = await storeService.getAll(page ? page : 1);
          if (res.status !== 200) {
            throw new Error("Failed to fetch!");
          } else {
            setResult(res.data);
          }
        }
      } catch (err: any) {
        const error = err.toString();
        //message.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return [result, loading];
  //return [result.stores, result.countries,  result.retailers, result.regions, result.channels, result.outlet_classes, result.manufacturers, result.sub_regions_1,loading];
}

export default useStore;
